import React from 'react';
import './ConfirmDialog.css'; // Create your styling here

const UserInfo = ({ open, title, username, userphone, useremail, userrole, plan, onCancel }) => {
  if (!open) return null;

  return (
    <div className="confirm-dialog-overlay">
      <div className="confirm-dialog-box">
        <h3>{title}</h3>
        <p><strong>Name:</strong> {username}</p>
        <p><strong>Email:</strong> {useremail}</p>
        <p><strong>Phone:</strong> {userphone}</p>
        <p><strong>Role:</strong> {userrole}</p>
        <p style={{textTransform: 'capitalize'}}><strong>Plan:</strong> {plan}</p>
        <div className="dialog-buttons">
          <button className="cancel-btn" onClick={onCancel}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default UserInfo;